import PrivacyPolicy from "../../layouts/PrivacyPolicy/PrivacyPolicy";
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount/ScrollToTopOnMount';

const PrivacyPolicyPage = () => {
    return (
        <>
            <ScrollToTopOnMount />
            <PrivacyPolicy />
        </>
    )
}

export default PrivacyPolicyPage;